<template>
  <div class="">
    <div class="">
      <div class="w-50 w-sm-100 m-md-auto sign-up mobile">
        <div class="">
          <div
            v-if="
              validateInput(error, 'fullname', null) ||
              validateInput(error, 'nofullnametext', null) ||
              validateInput(error, 'email', null) ||
              validateInput(error, 'noemailtext', null) ||
              validateInput(error, 'phone', null) ||
              validateInput(error, 'nophonetext', null)
            "
            class="error-message error-text"
          >
            <div
              v-if="
                validateInput(error, 'fullname', null) ||
                validateInput(error, 'nofullnametext', null)
              "
            >
              Please enter name with minimum length of
              {{ min_name_length }} characters
            </div>
            <div v-else-if="validateInput(error, 'noemailtext', null)">
              Please enter an email address
            </div>
            <div v-if="validateInput(error, 'email', null)">
              Please enter a valid email address
            </div>
            <div v-if="validateInput(error, 'nophonetext', null)">
              Please enter a phone number
            </div>
            <div v-if="validateInput(error, 'phone', null)">
              Please enter a valid phone number
            </div>
          </div>

          <div>
            <div
              class="
                w-100
                pure-material-textfield-outlined
                mt-2
                d-flex
                input-group
                mb-0
                input-icons
                flex-column
              "
            >
              <div :class="fetch_data.type === 'email' ? 'order-1' : 'order-2'">
                <label
                  class="
                    w-100
                    pure-material-textfield-outlined
                    input-group
                    mb-0
                    input-icons
                    mb-0
                  "
                >
                  <input
                    id="email"
                    placeholder=" "
                    v-model.trim="fetch_data.email"
                    autocomplete="off"
                    class="input-field"
                    :disabled="fetch_data.type === 'email'"
                  />
                  <span>Email</span>
                  <v-icon
                    name="check-circle"
                    scale="1.2"
                    color="green"
                    class="icon"
                    v-if="fetch_data.type === 'email'"
                  ></v-icon>
                </label>
                <span class="sub-mail-text mb-3 mt-1 d-block"
                  >We will send you project details and updates to this email</span
                >
              </div>
              <div
                class="d-flex flex-column mb-3"
                :class="fetch_data.type === 'phone' ? 'order-1' : 'order-2'"
              >
                <div class="input-icons d-flex mb-0">
                  <AIntTelephone
                    :placeholder="'PhoneNumber'"
                    validateStatus="success"
                    :phoneInput="phoneInput"
                    @change="mobileInputChange"
                    :disabled="fetch_data.type === 'phone'"
                    class="input-field p-0"
                    id="tel"
                  ></AIntTelephone>
                  <v-icon
                    name="check-circle"
                    scale="1.2"
                    color="green"
                    class="icon number-icon"
                    v-if="fetch_data.type === 'phone'"
                  ></v-icon>
                </div>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="whatsapp_enable"
                  name="whatsapp_enable_checkbox"
                  class="mt-1"
                >
                  Send me updates on WhatsApp
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <label
            class="w-100 pure-material-textfield-outlined mb-2"
            :class="{
              'error-input': validateInput(error, 'fullname', true),
              'error-no-input': validateInput(error, 'nofullnametext', true),
            }"
          >
            <input
              placeholder=" "
              v-model="fetch_data.fullname"
              name="fullname"
              id="fullname"
              @keyup.enter="createAccount"
              v-on:focus="resetError"
              autocomplete="off"
            />
            <span>Full Name</span>
          </label>

          <div class="pt-3 d-flex">
            <button
              class="btn-danger mdc-theme--primary-shape-bg w-100 go-back mr-2"
              name="SubmitLogin"
              type="submit"
              v-on:click="back"
            >
              Back
            </button>
            <button
              type="submit"
              name="SubmitLogin"
              class="btn-danger mdc-theme--primary-shape-bg w-100"
              v-on:click="createAccount()"
            >
            SIGN UP
            </button>
          </div>
        </div>
      </div>

      <!-- <div v-if="!iOS()">
        <hr class="hr-text" data-content="SOCIAL LOGIN" />
        <SocialMedia></SocialMedia>
      </div> -->
    </div>
  </div>
</template>

<script>
import Services from "../services";
import Validation from "./mixins/Validation";
import CountryCode from "./mixins/CountryCode";
import CommonCode from "./mixins/CommonCode";
import UserUtils from "./mixins/UserUtils";
import { EventBus } from "../events";
import { AIntTelephone } from "@canvas/componentlibrary";
import { SHELL_APP_HEADER_ICON } from "./mixins/Global";

export default {
  mixins: [Validation, CountryCode, CommonCode, UserUtils],

  components: {
    AIntTelephone,
  },

  data() {
    return {
      min_name_length: 4,
      phoneInput: {
        number: "",
        initialisationOptions: {
          allowDropdown: true,
          formatOnDisplay: true,
          nationalMode: true,
          initialCountry: "in",
          preferredCountries: ["in", "sg", "my", "sa"],
          separateDialCode: true,
        },
      },
      whatsapp_enable: true,
    };
  },

  methods: {
    mobileInputChange(event) {
      this.phoneInput.number = event.number;
      this.fetch_data.mobile = this.phoneInput.number;
      this.fetch_data.isdcode =
        "+" + event.intlTelInputSettings.activeItem.dataset.dialCode;
    },
    createAccount() {
      EventBus.$emit("captureGAEvent", "signup_interaction", { signin_method: 'email/mobile',
        cta_text: "SIGN UP"});
      let properties = {
        ...this.fetch_data,
      };
      if (!this.formValidation()) {
        return this.formValidation();
      }

      const payload = {
        email: this.fetch_data.email,
        name: this.fetch_data.fullname,
        phone: this.fetch_data.isdcode + this.fetch_data.mobile,
        type: this.fetch_data.type,
        'is_verified': true
      };
        payload["whatsapp_enable"] = this.whatsapp_enable;
        this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
        msg: null,
        errorCode: 0,
      });
      Services.registerUserName(payload)
        .then((response) => {
          Services.loginUsingLtt(
            response.data.ltt,
            this.$route.query.login_challenge
          ).then((responseData) => {
            let analyticsData = {};
            if (responseData && responseData.data && responseData.data.user) {
              const { user } = responseData.data;
              analyticsData = {
                name: user.name,
                email: user.email,
                phoneNo: user.phone,
                customerId: user.customerId,
                method: properties.method,
              };
            }
            const callbackAfterSignedUp = () => {
              this.lemniskCbExecuted = true;
              this.windowRedirection(responseData.data.redirect_uri);
            };
            //reset lemniskCbExecuted flag if already set
            if (this.lemniskCbExecuted) this.lemniskCbExecuted = false;
            EventBus.$emit(
              "captureEvents",
              "accounts_customer:new-customer_created",
              analyticsData,
              callbackAfterSignedUp
            );

            EventBus.$emit(
              "captureEvents",
              "accounts_customer:customer_login_identify",
              analyticsData,
              callbackAfterSignedUp,
              {}
            );
            //explicitly call our callback in case of lemnisk fails
            this.handleCallbackIfEventFails(
              callbackAfterSignedUp,
              "callbackAfterSignedUp"
            );
          });
        })
        .catch((err) => {
          this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
            msg: err.response.data.message,
            errorCode: 0,
          });
        });
    },

    formValidation() {
      this.error = {};
      let errorMessage = false;
      if (!this.fetch_data.email) {
        this.error.noemailtext = true;
        errorMessage = true;
      } else if (!this.isEmailValid(this.fetch_data.email)) {
        this.error.email = true;
        errorMessage = true;
      }

      if (!this.fetch_data.mobile) {
        this.error.nophonetext = true;
        errorMessage = true;
      } else if (
        !this.isPhoneValid(this.fetch_data.mobile, this.fetch_data.isdcode)
      ) {
        this.error.phone = true;
        errorMessage = true;
      }

      if (!this.fetch_data.fullname) {
        this.error.nofullnametext = true;
        errorMessage = true;
      } else if (
        !this.alphabetValid(this.fetch_data.fullname, this.min_name_length)
      ) {
        this.error.fullname = true;
        errorMessage = true;
      }
      if (errorMessage === true) return false;
      else return true;
    },
  },

  beforeMount() {
    if (!this.$route.query.login_challenge) {
      Services.getDefaultUrl().then((response) => {
        this.windowRedirection(response.data.redirect_uri);
      });
    }
      if(!this.$route.params.username){
        this.$router.push({ name: this.getGuestDefaultPage() }, () => {});
      }
    // if (this.fetch_data.mobile) this.list = ["mobile", "email"];
    const title = "Complete Your Profile"
    this.$store.commit("projects/SET_HEADER_TITLE", {
      title: title,
      showBackIcon: false,
    });
    this.sendPostMessageToShellApp("UI_CHANGE", {
        headerTitle: title,
        setHeaderIcon: SHELL_APP_HEADER_ICON.BACK,
    });
    this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
      msg: null,
      errorCode: 0,
    });
    this.phoneInput.number = this.fetch_data.mobile
      ? this.fetch_data.mobile
      : "";
    this.phoneInput.initialisationOptions.initialCountry = this.fetch_data
      .mobile
      ? this.fetch_data.countryCode
      : "in";
  },
  beforeDestroy() {
    this.$store.commit("projects/SET_NOTIFICATION_TOKEN", {
      msg: null,
      errorCode: 0,
    });
  },
};
</script>
<style lang="scss" scoped>
.input-icons .fa-icon {
  position: absolute;
}

.input-icons {
  width: 100%;
  margin-bottom: 10px;
}

.icon {
  font-size: 1.2em;
  padding: 10px;
  color: #469e59;
  min-width: 50px;

  height: 37px;
  margin-left: -45px;
  margin-top: 10px;
}

.input-field {
  width: 100%;
  padding: 15px 13px;
}

h2 {
  color: green;
}
.input-group {
  position: relative;
  display: inline-block;
}
.input-group-text {
  position: absolute;
  right: 0;
  top: 0;
}

input {
  padding-right: 20px; /* = icon width if you don't want the password to go under the icon */
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.number-icon {
  right: 0;
}
.sub-mail-text {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* identical to box height, or 133% */

  /* on-surface/secondary */

  color: #666666;
}
.input-2Z0b:disabled {
  border: 1px solid #e1e5ed;
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
<style>
.custom-control-label::after {
  top: 0.1rem;

  background-color: white;
  border-color: #eb595f;
  border: 1px solid #eb595f;
  border-radius: 4px;
}
.custom-control-label::before {
  top: 0.1rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23ffffff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e");
  background-color: #eb595f;
}
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
  font-size: 13px;
  color: #666666;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
}
</style>
